export default {
  main: {
    title: "Year in Calling 2020",
    desc: "See how the world communicated through Truecaller in 2020!",
    tw: "See how the world communicated through @Truecaller in 2020! #YearInCalling",
    wa: "See how the world communicated through Truecaller in 2020! Take a look!",
    url: "https://tclr.se/YearInCalling2020"
  },
  sortQuiz: {
    title: "Year in Calling 2020",
    desc: "Can you guess the top 5 most spammed countries in the world on @Truecaller's #YearInCalling?",
    tw: "Can you guess the top 5 most spammed countries in the world on @Truecaller's #YearInCalling?",
    wa: "Can you guess the top 5 most spammed countries in the world on Truecaller's Year in Calling?",
    url: "https://tclr.se/39SSrqr"
  },
  sliderQuiz: {
    title: "Year in Calling 2020",
    desc: "Take a guess on how many calls this Indian telecom made in 2020 via @Truecaller #YearInCalling",
    tw: "Take a guess on how many calls this Indian telecom made in 2020 via @Truecaller #YearInCalling",
    wa: "Take a guess on how many calls this Indian telecom made in 2020 via Truecaller's Year in Calling review.",
    url: "https://tclr.se/3glPMa2"
  },
  multipleChoiceQuiz: {
    title: "Year in Calling 2020",
    desc: "Can you guess which country talks to most? Play your luck on @Truecaller's #YearInCalling!",
    tw: "Can you guess which country talks to most? Play your luck on @Truecaller's #YearInCalling!",
    wa: "Can you guess which country talks to most? Play your luck on Truecaller's Year in Calling review.",
    url: "https://tclr.se/3otmcCi"
  },
}